import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    loadCandidateClinicalHistory,
    loadCandidateClinicalHistorySuccess,
    loadCandidateClinicalHistoryFailed,
    loadSubmittalNotes,
    loadSubmittalNotesFailed,
    loadSubmittalNotesSuccess
} from '../actions/clinical-review-history.actions';
import { AccountManagersService } from 'src/app/accountmanagers/accountmanagers.service';
import { catchError, mergeMap, of, switchMap } from 'rxjs';
import { ClinicalService } from '../../clinical.service';

@Injectable()
export class ClinicalReviewHistoryEffects {
    getCandidatesClinicalHistory$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadCandidateClinicalHistory),
            switchMap((action) =>
                this.clinicalService$.getClinicalReviewHistory(action.candidateId).pipe(
                    mergeMap((response) => [
                        loadCandidateClinicalHistorySuccess({
                            candidateId: action.candidateId,
                            history: response
                        })
                    ]),
                    catchError((error: unknown) =>
                        of(
                            loadCandidateClinicalHistoryFailed({
                                error: "Failed to get Candidate's Clinical History",
                                exception: error
                            })
                        )
                    )
                )
            )
        );
    });

    getSubmittalNotes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadSubmittalNotes),
            switchMap((action) =>
                this.accountManagersService.getSubmittalNotes(action.submittalId).pipe(
                    mergeMap((response) => [
                        loadSubmittalNotesSuccess({
                            submittalId: action.submittalId,
                            notes: response
                        })
                    ]),
                    catchError((error: unknown) =>
                        of(loadSubmittalNotesFailed({ error: 'Failed to get Submittal Notes', exception: error }))
                    )
                )
            )
        );
    });

    constructor(
        private readonly actions$: Actions,
        private readonly clinicalService$: ClinicalService,
        private readonly accountManagersService: AccountManagersService
    ) {}
}
